/*
  Подтверждение удаления суда из справочника (вынесено из `SettingsCourtSections.jsx`
  21.10.2026, когда экран перерос норму размера после перехода на серверные страницы).

  У района домов не бывает, и прежний текст обещал ему «отвяжутся его дома (0)» - число,
  которое человек читает как потерю данных. Разведённые вкладки сделали это заметным
  (14.09.2026). Число домов участка приходит в строке суда (`buildings_count`).

  С 23.10.2026 (находка ревизоров) окно называет и число сканов протоколов, которые
  уйдут вместе с участком безвозвратно (`protocol_scans_count`). Число считает сервер:
  экран видит только одну страницу домов.
*/

import { Confirm } from './Common.jsx'
import { DISTRICT } from './useCourtDirectory.js'

export default function CourtRemoveConfirm({ court, busy, error, onCancel, onConfirm }) {
  return (
    <Confirm
      title={court.kind === DISTRICT ? 'Удалить районный суд?' : 'Удалить участок?'}
      action="Удалить"
      busy={busy}
      error={error}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      {court.kind === DISTRICT ? (
        <>
          Суд «{court.name}» перестанет быть адресатом иска. Пока на него ссылается хотя бы один
          участок, удаление не пройдёт: иначе участок остался бы без суда, а выяснилось бы это в
          день подачи.
        </>
      ) : (
        <>
          Вместе с участком «{court.name}» отвяжутся его дома ({court.buildings_count}). Заявления
          по их помещениям формироваться не будут, пока вы не привяжете дома заново.
          {court.protocol_scans_count > 0 ? (
            <p>
              Будут удалены и сканы протоколов собраний этих домов: {court.protocol_scans_count}.
              Восстановить их нельзя - после новой привязки сканы придётся загрузить заново.
            </p>
          ) : null}
        </>
      )}
    </Confirm>
  )
}
